import { render, staticRenderFns } from "./app-dialog.vue?vue&type=template&id=81852ac8&scoped=true&"
import script from "./app-dialog.vue?vue&type=script&lang=js&"
export * from "./app-dialog.vue?vue&type=script&lang=js&"
import style0 from "./app-dialog.vue?vue&type=style&index=0&id=81852ac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81852ac8",
  null
  
)

export default component.exports